<template>
	<component :is="type" :size="size" class="v5-spinner"></component>
</template>
<script>
	import Android from './child/android.vue';
	import Ios from './child/ios.vue';
	import Bubble from './child/bubble.vue';
	import Circles from './child/circles.vue';
	import Lines from './child/lines.vue';
	import Ripple from './child/ripple.vue';
	export default {
		name: 'v5-spinner',
		props: {
			type: {
				type: String,
				default: 'android'
			},
			size: String
		},
		components: {
			Android,
			Ios,
			Bubble,
			Circles,
			Lines,
			Ripple
		}
	};

</script>
<style lang="scss">
	@import './style.scss';
</style>
